// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1ZKte","errorLogs":"EditorFooter_errorLogs__1FYj6"};